import React, { useEffect, useState, useMemo, useCallback } from 'react';
import {
  Row,
  Col,
  Form,
  Select,
  Radio,
  Typography,
} from 'antd';

import {
  listCitiesByState,
  listJerseySizes,
  listPersonalInterests,
  listPurchaseFrquencies,
  listSupportReasons,
  listTeams,
} from '../../services/catalogs';
import debounce from 'lodash/debounce';
import { Alert } from 'antd';
import { Checkbox } from 'antd';
import { InputNumber } from 'antd';

const { Title } = Typography;
const INTEREST_MIN = 3;

const FanProfile = () => {
  const form = Form.useFormInstance();

  const [cities, setCities] = useState([]);
  const [supportReasons, setSupportReasons] = useState([]);
  const [teams, setTeams] = useState([]);
  const [loadingCities, setLoadingCities] = useState(false);
  const stateId = form.getFieldValue('stateId');
  const [interests, setInterests] = useState([]);
  const [purchaseFrequencies, setPurchaseFrequencies] = useState([]);
  const [jerseySizes, setJerseySizes] = useState([]);

  /* ========================
    Cargar catálogos
  ========================= */
  useEffect(() => {
      listSupportReasons().then(setSupportReasons);
      listTeams().then(setTeams);
      listPersonalInterests().then(setInterests);
      listPurchaseFrquencies().then(setPurchaseFrequencies);
      listJerseySizes().then(setJerseySizes);
      if (stateId) {
        listCitiesByState(stateId).then(setCities);
      }
  }, [stateId]);

  const fetchCities = useCallback(async (value) => {
      if (!value) return;

      setLoadingCities(true);

      try {
        await listCitiesByState(stateId, value).then(setCities);
      } finally {
        setLoadingCities(false);
      }
    }, [stateId]);


  const debouncedFetchCities = useMemo(
    () => debounce(fetchCities, 500),
    [fetchCities]
  );

  return (
    <>
      <Title level={5}>Aficionado</Title>
      {!stateId && (
        <Alert
          type="warning"
          message="Primero selecciona el estado en la pestaña de información general"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}
      {/* Estado / Ciudad */}
      <Row gutter={16}>
        <Col md={8}>
          <Form.Item
            label="Ciudad"
            name={['fanProfile', 'cityId']}
            rules={[{ required: true, message: 'Campo obligatorio' }]}
          >
            <Select
              showSearch
              placeholder="Selecciona una ciudad"
              loading={loadingCities}
              filterOption={false}
              onSearch={debouncedFetchCities}
              notFoundContent={loadingCities ? 'Buscando...' : 'Sin resultados'}
              disabled={!stateId}
              options={cities.map(c => ({
                value: c.id,
                label: c.name,
              }))}
            />
          </Form.Item>
        </Col>
      </Row>

      {/* ¿A quién vienes a apoyar? */}
      <Form.Item
        label="¿A quién vienes a apoyar?"
        name={['fanProfile', 'supportReasonId']}
        rules={[{ required: true, message: 'Campo obligatorio' }]}
      >
        <Radio.Group>
          {supportReasons.map(r => (
            <Radio key={r.id} value={r.id}>
              {r.name}
            </Radio>
          ))}
        </Radio.Group>
      </Form.Item>

      {/* Equipo favorito */}
      <Form.Item
        label="Equipo profesional favorito"
        name={['fanProfile', 'teamId']}
        rules={[{ required: true, message: 'Campo obligatorio' }]}
      >
        <Select
          placeholder="Selecciona un equipo"
          options={teams.map(t => ({
            value: t.id,
            label: t.name,
          }))}
        />
      </Form.Item>

      {/* Intereses */}
        <Title level={5}>Intereses personales</Title>
  
        <Form.Item
          name={['fanProfile', 'interests']}
          rules={[
            {
              validator: (_, value) =>
                value?.length >= INTEREST_MIN
                  ? Promise.resolve()
                  : Promise.reject(
                      new Error(`Selecciona al menos ${INTEREST_MIN} intereses`),
                    ),
            },
          ]}
        >
          <Checkbox.Group>
            <Row>
              {interests.map(i => (
                <Col span={8} key={i.id}>
                  <Checkbox value={i.id}>{i.name}</Checkbox>
                </Col>
              ))}
            </Row>
          </Checkbox.Group>
        </Form.Item>
      {/* Frecuencia compra */}
      <Form.Item
        label="¿Con qué frecuencia compras online?"
        name={['fanProfile', 'purchaseFrequencyId']}
        rules={[{ required: true }]}
      >
        <Radio.Group>
          {purchaseFrequencies.map(p => (
            <Radio key={p.id} value={p.id}>
              {p.name}
            </Radio>
          ))}
        </Radio.Group>
      </Form.Item>

      {/* Jersey */}
      <Form.Item
        label="Talla de Jersey"
        name={['fanProfile', 'jerseySizeId']}
        rules={[{ required: true }]}
      >
        <Radio.Group>
          {jerseySizes.map(j => (
            <Radio key={j.id} value={j.id}>
              {j.name}
            </Radio>
          ))}
        </Radio.Group>
      </Form.Item>
      <Row gutter={16}>
        <Col md={6}>
          <Form.Item
            label="Talla de zapato"
            name={['fanProfile', 'shoeSize']}
            rules={[{ required: true }]}
          >
            <InputNumber
              min={20}
              max={50}
              style={{ width: '100%' }}
              placeholder="Ej. 27"
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default FanProfile;
